<template>
  <v-container fluid grid-list-xl pt-0>
    <v-layout wrap>
      <v-flex xs12>
        <material-card
          :title="pageTitle + ' (' + summaryDate + ')'"
          class="card-shrink card-padding v-card__first"
          color="general"
        >
          <v-form>
            <v-container py-0 class="mw-100">
              <v-layout wrap>
                <v-flex xs12 lg2>
                  <v-menu
                    v-model="summaryDateMenu"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="summaryDate"
                      label="時間"
                      prepend-icon="event"
                    />
                    <v-date-picker
                      v-model="summaryDate"
                      :color="theme==='dark'?'danger':'general'"
                      no-title
                      scrollable
                    />
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 lg2>
                  <v-autocomplete
                    v-model="summaryVendor"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryVendorMenu"
                    label="供應商（選填）"
                    clearable
                    outlined
                  />
                </v-flex>
<v-flex xs12 sm6 lg2>
                  <v-autocomplete
                    v-model="summaryAsusDeviceIsn"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryAsusDeviceIsnMenu"
                    label="料號（選填）"
                    clearable
                    outlined
                  />
                </v-flex>
                <v-flex xs12 sm6 lg2>
                  <v-autocomplete
                    v-model="summaryFailRate"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="[
                      { text: 'All', value: 'All' },
                      { text: '> 1%', value: '0.01' },
                      { text: '> 3%', value: '0.03' }
                    ]"
                    label="Fail Rate"
                    outlined
                  />
                </v-flex>
                <v-flex lex-small
                  mt-3
                  xs12
                  lg1
                  text-xs-right
                  d-flex
                  align-items-center>
                  <v-btn class="mx-0 font-weight-light" color="general" @click="doSubmit()">
                    <v-icon class="mr-2">mdi-backup-restore</v-icon>查詢
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>

        <material-card>
          <v-data-table
            :headers="headers"
            :items="responseFailTable"
            :pagination.sync="pagination"
            multi-sort
            hide-actions
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span class="subheading font-weight-light text-general text--darken-3" v-text="header.text"/>
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.deviceIsn }}</td>
              <td>{{ item.processType }}</td>
              <td class="text-xs-right">{{ item.productionQty }}</td>
              <td class="text-xs-right">{{ item.failQty }}</td>
              <td class="text-xs-right">
                <v-chip :class="item.warningColor" small>{{ (item.failRate*100).toFixed(1) }}%</v-chip>
              </td>
              <td>{{ item.vendor }}</td>
              <td>
                <router-link
                  :to="statLink(item)"
                  target="_blank"
                >
                  <v-btn class="mx-0 mr-3 font-weight-light small" color="primary">
                    <v-icon class="mr-2">mdi-chart-bar</v-icon>當日統計
                  </v-btn>
                </router-link>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
      <v-flex
        class="v-flex__first"
        style="margin-top: 60px !important;"
        xs12
      >
        <material-card
          class="v-flex v-c3-chart"
          color="green"
        >
          <div
            class="w-100 chart-btn c3-chart"
            style="overflow-x: auto;">
            <material-notification
              color="brown"
              class="mb-3 h4 font-weight-bold"
              style="margin-top: 0px!important;"
            >
              生產不良率
            </material-notification>
            <vue-c3 :handler="handler_bar"/>
          </div>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="processingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        PROCESSING 處理中
      </p>
    </v-dialog>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import Vue from 'vue'
import VueC3 from 'vue-c3'
import 'c3/c3.min.css'
import { mapState } from 'vuex'
import qs from 'qs'
import Loading from '@/assets/img/loading.gif'
export default {
  name: 'CTQThermalPerformanceDaily',
  components: {
    VueC3
  },
  data () {
    return {
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      processingView: false,
      summaryDateMenu: false,
      summaryDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      summaryVendor: '',
      summaryAsusDeviceIsn: '',
      summaryProcessType: 'HP',
      summaryStage: 'PL1',
      summaryVendorMenu: [],
      summaryAsusDeviceIsnMenu: [],
      summaryFailRate: 'All',
      responseFailTable: [],
      barXaxisName: ['x'],
      barXaxisValue: ['ModelName'],
      barXaxisColor: ['#999999'],
      pagination: { rowsPerPage: -1, sortBy: 'failRate', descending: true },
      headers: [
        { sortable: true, text: '料號', value: 'deviceIsn' },
        { sortable: true, text: '製程別', value: 'processType' },
        { sortable: true, text: '生產數量', value: 'productionQty', align: 'right' },
        { sortable: true, text: '總不良數量', value: 'failQty', align: 'right' },
        { sortable: true, text: '總不良率', value: 'failRate', align: 'right' },
        { sortable: true, text: '供應商', value: 'vendor' },
        { sortable: false, text: '熱測數據', value: '' }
      ],
      handler_bar: new Vue()
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    pageTitle () {
      return (this.$route.meta && this.$route.meta.name) || '日 Performance 生產概況篩選'
    },
    pageBasePath () {
      const matched = this.$route.matched || []
      const last = matched[matched.length - 1] || {}
      const parent = matched[matched.length - 2] || {}
      const child = String(last.path || '').split('/')[0]
      return (parent.path || '/ctqThermalPerformance') + '/' + child
    },
    options_bar () {
      return {
        data: {
          x: 'x',
          columns: [
            this.barXaxisName,
            this.barXaxisValue
          ],
          labels: {
            format: function (v, id, i, j) { return v + '%' }
          },
          type: 'bar',
          colors: {
            ModelName: '#999999'
          },
          color: (color, d) => {
            return this.barXaxisColor[d.index]
          }
        },
        axis: {
          x: {
            type: 'category'
          },
          y: {
            tick: {
              format: function (value) { return value + '%' }
            }
          }
        },
        tooltip: {
          format: {
            title (d) {
            },
            value (value, ratio, id) {
            }
          }
        },
        grid: {
          x: {
            show: true
          },
          y: {
            show: true
          }
        },
        legend: {
          position: 'bottom',
          padding: 16,
          show: false
        },
        size: {
          width: (this.barXaxisName.length - 1) * 100,
          height: 500
        }
      }
    }
  },
  watch: {
    summaryDate () {
      this.summaryDateMenu = false
      this.loadPartNo()
    },
    summaryVendor () {
      this.loadPartNo()
    }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/thermalModule/pl1/hpDailyProdutionSummary')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          if (this.$route.params.searchDate) {
            this.summaryDate = this.$route.params.searchDate
          }
          const body = {
            type: 'thermal_module'
          }
          this.$http.get('/api/system/pmsPath/getCodeAndNameListByType?' + qs.stringify(body)).then(res => res.data)
            .then(res => {
              if (res.status === 'success') {
                const data = res.data
                this.summaryVendorMenu = [
                  { text: 'All', value: 'All' },
                  ...data.map(item => ({
                    text: item.code,
                    value: item.code
                  }))
                ]
                // if (this.tempFactory !== '') {
                //   this.summaryVendor = this.tempFactory
                // }
              }
            })
          this.loadPartNo()
          this.loadData()
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    loadPartNo () {
      let url = '/api/thermalModule/selectOption/partNo?processType=' + encodeURIComponent(this.summaryProcessType || 'HP')
      if (this.summaryVendor) {
        url += '&vendor=' + encodeURIComponent(this.summaryVendor)
      }
      if (this.queryStage()) {
        url += '&stage=' + encodeURIComponent(this.queryStage())
      }
      if (this.summaryDate) {
        url += '&queryStartDate=' + encodeURIComponent(this.summaryDate)
        url += '&queryEndDate=' + encodeURIComponent(this.summaryDate)
      }
      this.$http.get(url).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.summaryAsusDeviceIsnMenu = res.data
          }
        })
    },
    queryStage () {
      return this.summaryStage
    },
    statLink (item) {
      let url = '/thermalModule/pl1/hpTestDataStatistc?deviceIsn=' + item.deviceIsn +
        '&modelname=' + item.modelName +
        '&date=' + this.summaryDate +
        '&vendorpk=' + item.vendorPk +
        '&vendor=' + item.vendor +
        '&processType=' + (item.processType || this.summaryProcessType)
      if ((item.processType || this.summaryProcessType) === 'VC') {
        url += '&stage=' + encodeURIComponent(this.summaryStage || 'All')
      }
      return url
    },
    async loadData () {
      this.loadingView = true
      await this.handler_bar.$emit('init', this.options_bar)
      await this.doSubmit()
    },
    doSubmit () {
      this.loadingView = true
      const body = {
        queryStartDate: this.summaryDate,
        queryEndDate: this.summaryDate,
        vendor: this.summaryVendor === 'All' || !this.summaryVendor ? '' : this.summaryVendor,
        deviceIsn: this.summaryAsusDeviceIsn === 'All' || !this.summaryAsusDeviceIsn ? '' : this.summaryAsusDeviceIsn,
        processType: this.summaryProcessType || 'HP',
        failRate: this.summaryFailRate === 'All' ? null : Number(this.summaryFailRate),
        stage: this.queryStage()
      }
      this.$http.post('/api/thermalModule/failRateSummaryList', body).then(res => res.data)
        .then(res => {
          this.loadingView = false
          if (res.status === 'success') {
            this.barXaxisName = ['x']
            this.barXaxisValue = ['ModelName']
            this.barXaxisColor = []
            this.responseFailTable = res.data || []
            this.responseFailTable.forEach((r) => {
              this.barXaxisName.push(r.modelName || r.deviceIsn)
              this.barXaxisValue.push((Number(r.failRate) * 100).toFixed(1))
              this.barXaxisColor.push(r.warningColor || '#999999')
              this.handler_bar.$emit('init', this.options_bar)
            })
            if (!this.responseFailTable.length) {
              this.handler_bar.$emit('init', this.options_bar)
            }
          }
        })
    }
  }
}
</script>
